import styled from 'styled-components';

import Heading from 'src/commons/components/Heading';
import SubHeading from 'src/commons/components/SubHeading';
import {
  CARD_BREAKPOINT,
  colors,
  MOBILE_BREAKPOINT,
} from 'src/commons/constants';

export const AutoPayHeading = styled(Heading)`
  max-width: 17.5rem;
  line-height: 2rem;
`;

export const AutoPaySubHeading = styled(SubHeading)`
  min-height: 3.25rem;
  max-width: 23.375rem;
  margin: 0.8125rem 0 0;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${CARD_BREAKPOINT}) {
    padding: 0 2.5rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 0 1rem;
  }
`;
